export function unsigned(int) {
    return abs(int);
}
export function abs(int) {
    return Math.abs(int);
}
